/**
 * 配置表字段内嵌表单
 * @author twu
 * @date 2021-06-23
 */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'dva';
import { Col } from 'antd'
import { framework_tool, component_tool } from '@/tool'
let { WizContainer } = framework_tool;
let { WizForm, WizButton } = component_tool;

class TableFieldEnumForm extends WizContainer {

  componentName = 'tableFieldEnumForm';

  static propTypes = {
    addTableFieldEnum: PropTypes.func,
    tableFieldEnumData: PropTypes.array
  };

  constructor(props) {
    super(props);
    this.state = {
    };
  }


  /** 添加枚举项 */
  _addItem() {
    let { addTableFieldEnum,item } = this.props;
    if (this.refs.tableFieldEnumForm && this.refs.tableFieldEnumForm.validateFields) {
      this.refs.tableFieldEnumForm.validateFields((err, values) => {
        if (!err) {
          if (addTableFieldEnum) {
            if (item && item.key) {
              values.key = item.key;
              values.update = true;
            }else {
              values.key = new Date().getTime() + '_'+ values.code + '_tableFieldEnum';
            }
            addTableFieldEnum(values);
            this.refs.tableFieldEnumForm.setFieldsValue({ code: null, value: null })
          }
        }
        return
      });
    }
  }

  validateNameRepeat = (rule, value, callback) => {
    let { tableFieldEnumData, item } = this.props;
    tableFieldEnumData.forEach((data, index) => {
      if (data.value === value && !item){
        callback('枚举名称已存在');
      }else if (data.value === value && (item && item.key != data.key)) {
        callback('枚举名称已存在');
      }
    });
    callback();
  }
  validateCodeRepeat = (rule, value, callback) => {
    let { tableFieldEnumData, item } = this.props;
    tableFieldEnumData.forEach((data, index) => {
      if (data.code === value && !item){
        callback('枚举编码已存在');
      }else if (data.code === value && (item && item.key != data.key)) {
        callback('枚举编码已存在');
      }
    });
    callback();
  }

  _render() {
    const columns = [

      {
        title: "枚举编码",
        name: "code",
        dataIndex: "code",
        formItem: {
          maxLength: 12,
          placeholder: '枚举编码最多输入12个字',
          rules: [{
            required: true,
            message: '请输入枚举编码',
          },
            { validator: this.validateCodeRepeat }
          ],
          initialValue: this.props.item && this.props.item.code ? this.props.item.code : null
        },
      },
      {
        title: "枚举名称",
        name: "value",
        dataIndex: "value",
        formItem: {
          maxLength: 24,
          placeholder: '枚举名称最多输入24个字',
          rules: [{
            required: true,
            message: '请输入枚举名称',
          },
            { validator: this.validateNameRepeat }
          ],
          initialValue: this.props.item && this.props.item.value ? this.props.item.value : null
        },
      },
    ]

    let onSubmit = this._addItem.bind(this);

    let formProps = {
      ref: 'tableFieldEnumForm',
      columns,
      onSubmit,
      record: null,
      preview: null,
      footer: <Col className="form-btns col-item"><WizButton type="primary" onClick={this._addItem.bind(this)}>保存</WizButton></Col>,
      formItemLayout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 17 }
      },
      style: { width: '100%' }
    }
    return (
      <WizForm key='tableFieldEnumForm' className={'form-inline'} {...formProps} />
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
  }
};

export default connect(mapStateToProps)(TableFieldEnumForm);
